export * from './allocation-seal-picture-control';
